import { Button, Select, Typography } from "antd";
import upperCaseSentences from "helpers/upperCaseSentences";
import { useCustomComments } from "context/providers/custom_comments";
import ManageModal from "./components/ManageModal";
import { useState } from "react";

const CustomComponents = ({ content, setContent }) => {
  const { custom_comment_options } = useCustomComments();
  const [is_open_manage_modal, setOpenManageModal] = useState(false);

  return (
    <>
      <Typography.Title style={{ margin: 0 }} level={5}>
        Stałe komentarze
      </Typography.Title>
      <Select
        style={{
          width: "100%",
          margin: "10px 0",
        }}
        showSearch
        placeholder="Wybierz komentarz"
        optionFilterProp="label"
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? "")
            .toLowerCase()
            .localeCompare((optionB?.label ?? "").toLowerCase())
        }
        value={null}
        options={custom_comment_options}
        onChange={(_, { label }) => {
          const value = content ? content + label : label;
          setContent(upperCaseSentences(value).slice(0, 400));
        }}
      />
      {is_open_manage_modal && (
        <ManageModal handleClose={() => setOpenManageModal(false)} />
      )}
      <Button
        type="primary"
        htmlType="submit"
        onClick={() => setOpenManageModal(true)}
      >
        Zarządzaj
      </Button>
    </>
  );
};

export default CustomComponents;
